const calculateAffiliateRate = (affiliate_rate, network_rate, display_rate, display_net_rate) => {
    // Get the affiliate rate, using the display rate and network rate

    if (!display_rate || display_rate == 0){
        // There is no display rate, we should use the affiliate rate        
        return affiliate_rate
    } else {
        let newAffiliateRate = affiliate_rate >= 0 ? affiliate_rate : 0

        if (display_net_rate > 0) {
            let ratioToMatch = Math.round(display_rate / display_net_rate * 10000) / 10000
            newAffiliateRate = Math.round(ratioToMatch * network_rate * 100) / 100
        }

        return parseFloat(newAffiliateRate)
    }

}

module.exports = calculateAffiliateRate